import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const formatDateTimePassedUtil = (timestamp?: number | null): string | undefined => {
  if (timestamp === null || timestamp === undefined) {
    return undefined;
  }

  const date = dayjs.unix(timestamp);
  const diffInHours = dayjs().diff(date, 'hour');

  if (diffInHours >= 22 && diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  return date.fromNow();
};
